<script>

import { mapActions } from 'vuex';
import TwentyService from '../services/twenty-service';
import * as C from '../store/modules/constants';

export default {
  name: 'TwCopyAndTranslateModal',
  props: {
    domains: {
      type: Array,
      default: () => ([]),
    },
    elementsToHandle: {
      type: Array,
      required: true,
      /*
          globalModelId: integer
          globalModelColumnName: string
          domainKeyOverrides: array|nullable
          selectKeyOverrides: array|nullable
          tableName: string
          sourceDomainId: int,
          selectedFromDomain: int,
          fromLanguageIsoOverride: null,
          sourceIsoOverride: null,
          toDomains: int[],
          shouldTranslate: bool,
          shouldCopySeo: bool,
          fieldNamesAndValuesToCopyAndTranslate: [ // array on this format
            { column_name: value}
          ],
          title: `Day: ${dayProgram.day}`,
      */
    },
  },
  data() {
    return {
      toggled: true,
      loading: false,
      elementsToHandleData: [],
      snackbarShow: false,
      snackBar: {
        success: false,
        error: false,
        message: '',
      },
      globalElementHandling: {
        selectedFromDomain: null,
        fromLanguageIsoOverride: null,
        toDomains: [],
        shouldTranslate: false,
        shouldCopySeo: false,
      },
    };
  },
  computed: {
    domainsData() {
      const domainsData = this.domains.map(domain => ({
        id: domain.id,
        name: domain.name,
        shortName: domain.shortName,
      }));
      domainsData.unshift({
        id: null,
        name: 'Select domain',
        shortName: 'Select domain',
      });
      return domainsData;
    },
    everyElementFilled() {
      return this.elementsToHandleData.every(element =>
      (element.selectedFromDomain || element.fromLanguageIsoOverride || element.disableSourceIsoOverride) && element.toDomains.length);
    },
  },
  created() {
    this.elementsToHandle.forEach(element => {
      this.elementsToHandleData.push({
        ...element,
        handledSuccess: false,
        handledError: false,
      });
    });
  },
  methods: {
    ...mapActions({
      copyAndTranslateContent: 'twenty/copyAndTranslateContent',
    }),
    toggleToDomains(element, domain) {
      const index = element.toDomains.indexOf(domain.id);
      if (index === -1) {
        element.toDomains.push(domain.id);
      } else {
        element.toDomains.splice(index, 1);
      }
    },
    copyAndTranslate() {
      this.loading = true;
      let elementsHandled = 0;
      this.elementsToHandleData.forEach(element => {
        const data = {
          globalModelId: element.globalModelId,
          globalModelColumnName: element.globalModelColumnName,
          tableName: element.tableName,
          sourceDomainId: element.selectedFromDomain,
          sourceIsoOverride: element.fromLanguageIsoOverride,
          targetDomainIds: element.toDomains,
          shouldTranslate: element.shouldTranslate,
          shouldCopySeo: element.shouldCopySeo,
          // Only use fieldsAndValues if copying from global texts. Make sure column names match target domain table.
          fieldNamesAndValuesToCopyAndTranslate: element.selectedFromDomain
            ? []
            : element.fieldNamesAndValuesToCopyAndTranslate,
          domainKeyOverrides: element.domainKeyOverrides ? element.domainKeyOverrides : null,
          selectKeyOverrides: element.selectKeyOverrides ? element.selectKeyOverrides : null,
        };
        TwentyService.copyAndTranslateContent(data).then(() => {
          element.handledError = false;
          element.handledSuccess = true;
        }).then(() => {
          elementsHandled += 1;
        }).catch(() => {
          element.handledSuccess = false;
          element.handledError = true;
        })
          .finally(() => {
            this.loading = false;
            if (elementsHandled === this.elementsToHandleData.length) {
              window.location.reload();
            }
          });
      });
    },
    setGlobal(element) {
      if (element.disableSourceIsoOverride) {
        element.selectedFromDomain = null;
        element.fromLanguageIsoOverride = null;
        element.isIsoOverride = true;
        return;
      }
      element.fromLanguageIsoOverride = element.fromLanguageIsoOverride
        ? element.fromLanguageIsoOverride = null
        : element.fromLanguageIsoOverride = 'EN';
      element.selectedFromDomain = null;
    },
    canToggleDomain(el, domain) {
      return el.fromLanguageIsoOverride || (el.disableSourceIsoOverride || (el.selectedFromDomain && el.selectedFromDomain !== domain.id));
    },
    setAllElementsFromDomain(event) {
      this.elementsToHandleData = this.elementsToHandleData.map(el => ({
        ...el,
        selectedFromDomain: event,
        fromLanguageIsoOverride: null,
      }));
    },
    setAllElementsGlobal(event) {
      let iso = null;
      if (event) {
        iso = 'EN';
      }

      this.elementsToHandleData = this.elementsToHandleData.map(el => {
        if (el.disableSourceIsoOverride) {
          return {
            ...el,
            selectedFromDomain: null,
            fromLanguageIsoOverride: null,
            isIsoOverride: true,
          };
        }
        return {
          ...el,
          selectedFromDomain: null,
          fromLanguageIsoOverride: iso,
          isIsoOverride: event,
        };
      });
    },
    toggleAllElementsToDomains(domain) {
      const index = this.globalElementHandling.toDomains.indexOf(domain.id);
      if (index === -1) {
        this.globalElementHandling.toDomains.push(domain.id);
      } else {
        this.globalElementHandling.toDomains.splice(index, 1);
      }
      this.elementsToHandleData = this.elementsToHandleData.map(el => ({
        ...el,
        toDomains: this.globalElementHandling.toDomains,
      }));
    },
    setAllElementsShouldTranslate() {
      this.elementsToHandleData = this.elementsToHandleData.map(el => ({
        ...el,
        shouldTranslate: this.globalElementHandling.shouldTranslate,
      }));
    },
  },
};
</script>

<template>
  <v-dialog
    v-model="toggled"
    max-width="800px"
  >
    <v-card class="text-lg-right pa-5">
      <div v-if="elementsToHandleData.length > 1">
        <h3 class="justify-self-start">Handle ALL elements</h3>
        <v-flex class="d-flex justify-space-between">
          <v-select
            v-model="globalElementHandling.selectedFromDomain"
            :items="domainsData"
            :loading="loading"
            :disabled="loading || globalElementHandling.fromLanguageIsoOverride"
            placeholder="Choose a domain to copy from"
            item-text="name"
            item-value="id"
            @change="setAllElementsFromDomain"
          />
          <v-checkbox
            v-model="globalElementHandling.fromLanguageIsoOverride"
            :disabled="loading"
            :loading="loading"
            label="Copy from global values"
            class="ml-5"
            @change="setAllElementsGlobal"
          />
        </v-flex>
        <v-flex
          v-if="globalElementHandling.selectedFromDomain || globalElementHandling.fromLanguageIsoOverride"
          class="d-flex justify-start align-center"
        >
          To domains:
          <v-btn
            v-for="domain in domainsData"
            v-if="canToggleDomain(globalElementHandling, domain) && domain.id !== null"
            :key="`domain-btn-${domain.id}`"
            :disabled="!domains.length || loading"
            :loading="loading"
            :color="globalElementHandling.toDomains.includes(domain.id) ? 'primary' : 'secondary'"
            style="max-width: 10%"
            depressed
            small
            @click="toggleAllElementsToDomains(domain)"
          >
            {{ domain.shortName }}
          </v-btn>
        </v-flex>
        <v-flex class="d-flex mt-3 align-center">
          <v-checkbox
            v-if="globalElementHandling.toDomains.length"
            v-model="globalElementHandling.shouldTranslate"
            :disabled="loading"
            :loading="loading"
            label="Translate to selected domains (if not checked content will only be copied)"
            @change="setAllElementsShouldTranslate"
          />

        </v-flex>
        <hr class="mt-2 mb-5">
      </div>
      <div v-for="(elementToHandle, index) in elementsToHandleData" :key="`${index}-copy-translate`">
        <h3 class="justify-self-start">Handling: {{ elementToHandle.title }}</h3>
        <v-flex class="d-flex justify-space-between">
          <v-select
            v-model="elementToHandle.selectedFromDomain"
            :items="domainsData"
            :loading="loading"
            :disabled="loading || elementToHandle.isIsoOverride"
            :key="`v-select-${index}`"
            placeholder="Choose a domain to copy from"
            item-text="name"
            item-value="id"
            @change="elementToHandle.fromLanguageIsoOverride = null"
          />
          <v-checkbox
            v-model="elementToHandle.isIsoOverride"
            :disabled="loading"
            :loading="loading"
            label="Copy from global values"
            class="ml-5"
            @change="setGlobal(elementToHandle)"
          />
        </v-flex>
        <v-flex
          v-if="elementToHandle.selectedFromDomain || (elementToHandle.fromLanguageIsoOverride || elementToHandle.disableSourceIsoOverride)"
          class="d-flex justify-start align-center"
        >
          To domains:
          <v-btn
            v-for="domain in domainsData"
            v-if="canToggleDomain(elementToHandle, domain) && domain.id !== null"
            :key="`domain-btn-${domain.id}`"
            :disabled="!domains.length || loading"
            :loading="loading"
            :color="elementToHandle.toDomains.includes(domain.id) ? 'primary' : 'secondary'"
            style="max-width: 10%"
            depressed
            small
            @click="toggleToDomains(elementToHandle, domain)"
          >
            {{ domain.shortName }}
          </v-btn>
        </v-flex>
        <v-flex class="d-flex mt-3 align-center">
          <v-checkbox
            v-if="elementToHandle.toDomains.length"
            v-model="elementToHandle.shouldTranslate"
            :disabled="loading"
            :loading="loading"
            label="Translate to selected domains (if not checked content will only be copied)"
          />

        </v-flex>
        <div v-if="elementToHandle.handledSuccess" class="succesbanner d-flex justify-center">
          <div
            class="text-xs-center"
          >
            Successfully handled:  <b>{{ elementToHandle.title }}</b> (Refresh page to see changes)
          </div>
        </div>
        <div v-if="elementToHandle.handledError" class="errorbanner d-flex justify-center">
          <div class="text-xs-center">Something went wrong while handling:  <b>{{ elementToHandle.title }}</b></div>
        </div>
        <hr v-if="index !== elementsToHandleData.length - 1" class="mt-2 mb-3">
      </div>
      <v-btn
        v-if="everyElementFilled"
        class="success"
        @click="copyAndTranslate"
      >
        Copy
      </v-btn>
    </v-card>
  </v-dialog>
</template>

<style lang="scss">
@import './../assets/scss/variables.scss';
@import './../assets/scss/animations.scss';
.succesbanner {
  width: 100%;
  background-color: rgba(30, 255, 167, 0.54);
  color: black;
  border-radius: 5px;
  padding-bottom: 5px;
  padding-top: 5px;
}
.errorbanner {
  width: 100%;
  background-color: rgba(255, 45, 45, 0.54);
  color: black;
  border-radius: 5px;
  padding-bottom: 5px;
  padding-top: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/TwCopyAndTranslateModal.vue